export default __webpack_public_path__ + "static/media/piano toggle bg.9748d3de.svg";